// [SC] - accessibility



// Start - for accessibility of predictive search on header
function handlePredictiveSearchFocus(event) {
  // Get all predictive search elements on the page
  const predictiveSearches = document.querySelectorAll('predictive-search');
  predictiveSearches.forEach(predictiveSearch => {
    if (!predictiveSearch || !predictiveSearch.classList.contains('is-active')) {
      return;
    }
    const activeElement = document.activeElement;
    const isFocusWithin = predictiveSearch.contains(activeElement);
    if (!isFocusWithin) {
      // Find the predictive-search-results element inside
      const searchResults = predictiveSearch.querySelector('#predictive-search');
      if (searchResults) {
        // Clear the HTML content
        searchResults.innerHTML = '';
        // Add display none style
        searchResults.style.display = 'none';
        
        // Optional: Also remove any existing visibility classes or styles
        searchResults.classList.remove('visible', 'active', 'show');
      }
      
      // Remove the is-active class after clearing results
      predictiveSearch.classList.remove('is-active');
    }
  });
}
function handlePredictiveSearchClick(event) {
  // Small delay to allow focus to update before checking
  setTimeout(() => handlePredictiveSearchFocus(event), 0);
}
function handlePredictiveSearchEscape(event) {
  if (event.key === 'Escape') {
    const predictiveSearches = document.querySelectorAll('predictive-search');
    
    predictiveSearches.forEach(predictiveSearch => {
      if (predictiveSearch && predictiveSearch.classList.contains('is-active')) {
        const searchResults = predictiveSearch.querySelector('#predictive-search');
        if (searchResults) {
          searchResults.innerHTML = '';
          searchResults.style.display = 'none';
        }
        predictiveSearch.classList.remove('is-active');
      }
    });
  }
}
// Listen for both focus changes and clicks
document.addEventListener('focusin', handlePredictiveSearchFocus);
document.addEventListener('click', handlePredictiveSearchClick);
// Handle ESC key to close predictive search
document.addEventListener('keydown', handlePredictiveSearchEscape);
// END - for accessibility of predictive search on header






// Start - for accessibility of header main menu's link with dropdown to have them toggle to show/hide submenu only when using keyboard without redirect, specially while using NVDA screen reader tool
window.addEventListener('load', function () {
    let lastMoveTime = 0;
    document.addEventListener(
        'mousemove',
        function (e) {
        if (e.isTrusted) lastMoveTime = Date.now();
        },
        true
    );
    document.querySelectorAll('summary.site-nav__link--has-dropdown').forEach(function (oldSummary) {
        const summary = oldSummary.cloneNode(true);
        oldSummary.parentNode.replaceChild(summary, oldSummary);

        const detail = summary.closest('details');
        const href = summary.getAttribute('data-link');

        let pointerArmed = false;
        let keyTime = 0;

        summary.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            keyTime = Date.now();
        }
        });

        summary.addEventListener('mousedown', function (e) {
        if (e.isTrusted && e.button === 0) pointerArmed = true;
        });

        summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const now = Date.now();
        const keyRecent = now - keyTime < 1000;
        const moveRecent = now - lastMoveTime < 1500;
        const byMouse = pointerArmed && moveRecent && !keyRecent;

        pointerArmed = false;

        if (!detail.hasAttribute('open')) {
            detail.setAttribute('open', '');
            detail.setAttribute('aria-expanded', 'true');
            summary.setAttribute('aria-expanded', 'true');
        } else if (byMouse && href) {
            window.location.href = href;
        } else {
            detail.removeAttribute('open');
            detail.setAttribute('aria-expanded', 'false');
            summary.setAttribute('aria-expanded', 'false');
        }
        });
    });
});
// END - for accessibility of header main menu's link with dropdown (have them toggle to show/hide submenu only when using keyboard without redirect, specially while using NVDA screen reader tool)












// Start- For mobile burger menu accessbility (focus on proper main menu and submenu on mobile when clicking main menu link which has inner sub-menu)
document.addEventListener('click', function (e) {
  const btn = e.target.closest('button.js-toggle-submenu');
  if (!btn) return;

  // Case 1: clicked button has data-target
  const targetVal = btn.getAttribute('data-target');

  if (targetVal) {
    const parentEl = document.querySelector('[data-parent="' + CSS.escape(targetVal) + '"]');
    if (parentEl) {
      const focusBtn = parentEl.querySelector('button.js-toggle-submenu');
      if (focusBtn) focusBtn.focus();
    }
    return;
  }

  // Case 2: clicked button has NO data-target, so find closest data-parent
  const closestParent = btn.closest('[data-parent]');
  if (!closestParent) return;

  const parentVal = closestParent.getAttribute('data-parent');
  if (!parentVal) return;

  const focusBtn = document.querySelector(
    'button.js-toggle-submenu[data-target="' + CSS.escape(parentVal) + '"]'
  );

  if (focusBtn) focusBtn.focus();
});
// END - For mobile burger menu accessbility (focus on proper main menu and submenu on mobile when clicking main menu link which has inner sub-menu)





















// Start - for accessibility of Okendo review app of homepage (add a skip button link to skip the testimonial and go to next section)
(function() {
  // Find the testimonials carousel
  const testimonialsCarousel = document.querySelector('div[data-oke-carousel][data-oke-header-text="Testimonials"]');
  
  if (!testimonialsCarousel) return;
  
  // Find the parent Shopify section
  const currentSection = testimonialsCarousel.closest('.shopify-section');
  
  if (!currentSection) return;
  
  // Find the next Shopify section
  let nextSection = currentSection.nextElementSibling;
  while (nextSection && !nextSection.matches('.shopify-section')) {
    nextSection = nextSection.nextElementSibling;
  }
  
  if (!nextSection) return;
  
  // Find the first focusable element in the next section
  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ];
  
  let focusableElement = null;
  for (const selector of focusableSelectors) {
    focusableElement = nextSection.querySelector(selector);
    if (focusableElement) break;
  }
  
  // Target is either the focusable element or the section itself
  const targetElement = focusableElement || nextSection;
  
  // Remove existing skip link if present
  const existingLink = currentSection.querySelector('.skip-to-next-section');
  if (existingLink) existingLink.remove();
  
  // Create skip link
  const skipLink = document.createElement('a');
  skipLink.href = `#${targetElement.id || (targetElement.id = 'skip-target-' + Date.now())}`;
  skipLink.className = 'skip-to-next-section';
  skipLink.textContent = 'Skip to next section';
  skipLink.setAttribute('aria-label', 'Skip testimonials and go to next section. Or browse multiple testimonials contained on the slider of this testimonial section');
  
  // Style the skip link (hidden until focused)
  skipLink.style.cssText = `
    position: absolute;
    left: -9999px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
    z-index: 9999;
  `;
  
  // Show on keyboard focus
  skipLink.addEventListener('focus', () => {
    skipLink.style.cssText = `
      position: fixed;
      left: 10px;
      top: 10px;
      width: auto;
      height: auto;
      padding: 10px 15px;
      background: white;
      color: black;
      border: 2px solid black;
      border-radius: 4px;
      text-decoration: none;
      font-weight: bold;
      z-index: 9999;
    `;
  });
  
  skipLink.addEventListener('blur', () => {
    skipLink.style.cssText = `
      position: absolute;
      left: -9999px;
      width: 1px;
      height: 1px;
      overflow: hidden;
      z-index: 9999;
    `;
  });
  
  // Handle click - focus on the target element
  skipLink.addEventListener('click', (e) => {
    e.preventDefault();
    const target = document.getElementById(targetElement.id);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  
  // Add skip link at the beginning of the current section
  currentSection.insertBefore(skipLink, currentSection.firstChild);
})();
// END - for accessibility of Okendo review app of homepage (add a skip button link to skip the testimonial and go to next section)











// Start - for accessibility of Okendo review app of homepage (remove links and images from being in tab index so that screen reader can easily go through the testimonials)
(function() {
  function applyAccessibilityChanges() {
    var reviewSection = document.querySelector('.oke-reviewCarousel-reviews');
    if (!reviewSection) return false;

    var changed = false;

    // Add tabindex="-1" and aria-hidden="true" to all <a> tags
    var links = reviewSection.querySelectorAll('a');
    links.forEach(function(link) {
      if (link.getAttribute('tabindex') !== '-1') {
        link.setAttribute('tabindex', '-1');
        changed = true;
      }
      if (link.getAttribute('aria-hidden') !== 'true') {
        link.setAttribute('aria-hidden', 'true');
        changed = true;
      }
    });

    // Add tabindex="-1" and aria-hidden="true" to all buttons
    var buttons = reviewSection.querySelectorAll('button');
    buttons.forEach(function(button) {
      if (button.getAttribute('tabindex') !== '-1') {
        button.setAttribute('tabindex', '-1');
        changed = true;
      }
      if (button.getAttribute('aria-hidden') !== 'true') {
        button.setAttribute('aria-hidden', 'true');
        changed = true;
      }
    });

    // Add aria-hidden="true" to all images
    var images = reviewSection.querySelectorAll('img');
    images.forEach(function(img) {
      if (img.getAttribute('aria-hidden') !== 'true') {
        img.setAttribute('aria-hidden', 'true');
        changed = true;
      }
    });

    return changed;
  }

  // Try immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      applyAccessibilityChanges();
    });
  } else {
    applyAccessibilityChanges();
  }

  // Retry periodically for lazy-loaded content (safe fallback)
  var retryInterval = setInterval(function() {
    var changed = applyAccessibilityChanges();
    // If we found and updated the section, we could stop after a few seconds
    // but keep going in case content inside changes
  }, 1000);

  // Stop retrying after 30 seconds to avoid infinite loop
  setTimeout(function() {
    clearInterval(retryInterval);
  }, 30000);

  // Also watch for DOM changes (more efficient than interval)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var shouldCheck = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          shouldCheck = true;
          break;
        }
      }
      if (shouldCheck) {
        applyAccessibilityChanges();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
// END - for accessibility of Okendo review app of homepage (remove links and images from being in tab index so that screen reader can easily go through the testimonials)